import { createSelector } from '@ngrx/store';
import { getCigTrackerState } from '../..';
import { getCigarettesForToday } from '../../normalized/selectors/count-by-day.selectors';

export const getCigCountToday = createSelector(
  getCigarettesForToday,
  (cigarettesToday) => {
    if (!cigarettesToday || !cigarettesToday.count) {
      return 0;
    }

    return cigarettesToday.count;
  }
);

export const getSmokeFree = createSelector(
  getCigTrackerState,
  cigTracker => cigTracker.smokeFree
);
